<!-- Form to reset Password -->

<div class="page-wrapper bg-gra-01 p-t-45 p-b-50">
  <div class="wrapper wrapper--w790">
      <div class="card card-5">
          <div class="card-heading">
              <h2 class="title">Reset Password Form</h2>
          </div>

          <!-- ng if for forgot password -->
          <div style="border-radius: 10px;">
              <form
              #ResetNewPwdForm="ngForm"
              (ngSubmit)="ResetNewPwdForm.valid && onSubmit(ResetNewPwdForm)"
              >
                  <!-- starting card body -->
                  <div class="card-body">
                      <div class="alert" *ngIf="serverErrorMessages">
                          <span>{{serverErrorMessages}}</span>
                      </div>
                      <div class="alert" *ngIf="successMessage">
                          <span>{{successMessage}}</span>
                      </div>
                      
                      <!-- username input -->
                      <div class="form-row">
                          <div class="name">USER NAME</div>
                          <div class="value">
                              <div class="input-group">
                                  <input class="input--style-5"
                                  type="text"
                                  #userName="ngModel"
                                  class="form-control"
                                  (ngModel)="userName"
                                  name="userName"
                                  required
                                  [ngClass]="{ 'invalid-textbox': ResetNewPwdForm.submitted && !userName.valid }"
                                  />
                                  <div *ngIf="ResetNewPwdForm.submitted && userName.errors">
                                      <label *ngIf="userName.errors.required" class="validation-message">
                                      This field is required.
                                      </label>
                                  </div>                                        
                              </div>
                          </div>
                      </div>
                      <!-- username input end -->
                      <!-- otp input -->
                      <div class="form-row">
                          <div class="name">ENTER OTP</div>
                          <div class="value">
                              <div class="input-group">
                                  <input class="input--style-5"
                                  type="text"
                                  #otp="ngModel"
                                  class="form-control"
                                  (ngModel)="otp"
                                  name="otp"
                                  required
                                  [ngClass]="{ 'invalid-textbox': ResetNewPwdForm.submitted && !otp.valid }"
                                  />
                                  <div *ngIf="ResetNewPwdForm.submitted && otp.errors">
                                      <label *ngIf="otp.errors.required" class="validation-message" >
                                      This field is required.
                                      </label>
                                  </div>  
                              </div>
                          </div>
                      </div>
                      <!-- otp input end -->
                      <!-- password input -->
                      <div class="form-row">
                          <div class="name">ENTER PASSWORD</div>
                          <div class="value">
                              <div class="input-group">
                                  <input class="input--style-5"
                                  type="password"
                                  #newPassword="ngModel"
                                  class="form-control"
                                  (ngModel)="newPassword"
                                  name="newPassword"
                                  required
                                  [ngClass]="{ 'invalid-textbox': ResetNewPwdForm.submitted && !newPassword.valid }"
                                 />
                                 <div *ngIf="ResetNewPwdForm.submitted && newPassword.errors?.minlength">
                                      <label class="validation-message" >
                                          Minimum 8 characters.
                                      </label>
                                 </div>
                              </div>
                          </div>
                      </div>
                      <!-- password input end -->
                      <!-- repPassword input -->
                      <div class="form-row">
                          <div class="name">REPEAT PASSWORD</div>
                          <div class="value">
                              <div class="input-group">
                                  <input class="input--style-5"
                                  type="password"
                                  #repeatPassword="ngModel"
                                  class="form-control"
                                  (ngModel)="repeatPassword"
                                  name="repeatPassword"
                                  required
                                  [ngClass]="{ 'invalid-textbox': ResetNewPwdForm.submitted && !repeatPassword.valid }"
                                  />
                                  <div *ngIf="ResetNewPwdForm.submitted && repeatPassword.errors?.minlength">
                                      <label class="validation-message">
                                          Minimum 8 characters.
                                      </label>
                                  </div>  
                              </div>
                          </div>
                      </div>
                      <!-- repPassword input end -->
                      <div>
                          <input type="submit" class="btn btn-primary" style="padding:10px;" value="Reset Password"/>
                      </div>
                      <div *ngIf="ResetNewPwdForm.submitted && newPassword.value != repeatPassword.value">
                        <label class="validation-message" >
                        Passwords must match
                        </label>
                      </div>
                  
                  </div>
                  <!-- end card body -->
              
              </form>
                
          </div>
          <!-- ng container for forgot password -->
      </div>
  </div>
</div>